/**
 * The Team gadgets' plain logic (components/home/gadgets: Who's here, Reviews and comments). Pure: the presence
 * snapshot, the project's notes (Messages), the comment threads, the suggestions and the handoff notes go in.
 */
import { activityOf, agentName } from '../presenceModel';
import { conversation, isUnread } from '../messagesModel';

/** The other people here now and the agents: `{ people: [{ id, name, initials, slot, activity, idle, viewer }], agents: [{ id, name }] }`. */
export function hereNow(presence) {
  const you = presence?.you || null;
  const people = (presence?.people || [])
    .filter((p) => p && (!you || p.id !== you.id))
    .map((p) => ({ id: p.id, name: p.name || 'Someone', initials: p.initials || '?', slot: p.slot ?? 0, activity: activityOf(p), idle: p.state === 'idle', viewer: p.role === 'viewer' }));
  const agents = (presence?.agents || []).filter((a) => a?.id).map((a) => ({ id: a.id, name: agentName(a, you) }));
  return { people, agents };
}

/**
 * How many messages for me are unread (Messages' own rule, utils/messagesModel isUnread): `seen` the read marks
 * (readMarks) or one time; `members` to know who a direct message came from.
 */
export const unreadCount = (notes, me, seen, members = []) => (me ? conversation(notes || []).filter((note) => isUnread(note, me, seen, { members })).length : 0);

/**
 * Reviews: the open comment threads (newest first), the suggestions waiting for a decision, the handoff notes left for
 * me (or for everyone) that I have not dismissed. Each list null when its answer is missing.
 */
export function reviewSummary({ threads = null, suggestions = null, handoffs = null } = {}) {
  const open = threads ? threads.filter((t) => t && !t.resolved).sort((a, b) => String(b.at || '').localeCompare(String(a.at || ''))) : null;
  const waiting = suggestions ? suggestions.filter((s) => s && (s.status === 'pending' || !s.status)) : null;
  return { threads: open, suggestions: waiting, handoffs: handoffs ? handoffs.filter(Boolean) : null };
}
